module.exports = __webpack_public_path__ + "50df69975afffe94eb54c8068d27edb4.pdf";